export const PARTIAL_UTTERANCE_ID: number = -1;
